











import CSelectButtons, {
  CSelectButtonsPropsItems,
} from '@/components/Helper/Form/CSelectButtons.vue';
import Vue, { PropType } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import APIBuilder from '@quangphuc/frontend-api-builder';
import Entity from '@/entities/entity';

@Component<CSelectButtonsApi>({
  components: { CSelectButtons },
})
export default class CSelectButtonsApi extends Vue {
  @Prop()
  public store!: string;

  @Prop({ type: [String, Number] as PropType<string | number>, default: '1/1' })
  public size!: string | number;

  @Prop({ type: [String, Number] as PropType<string | number>, default: '1/1' })
  public pcSize!: string | number;

  @Prop()
  public value!: any;

  @Prop({ type: String, default: 'name' })
  public textColumn!: 'id' | 'name';

  @Prop({ type: String, default: 'id' })
  public valueColumn!: 'id' | 'name';

  @Prop({ type: Array as PropType<string[]> })
  public errorMessages!: string[];

  public apiBuilder: APIBuilder<Entity & { name: string }> = APIBuilder.store(
    this.store,
  );

  items: CSelectButtonsPropsItems[] = [];

  async created() {
    const [rows] = await this.apiBuilder.order('id', 'DESC').getMany();
    this.items = rows.map((row) => ({
      text: row[this.textColumn] as string,
      value: row[this.valueColumn],
    }));
  }
}
